import {Component, OnInit, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {UsersService} from '../../_services/data/users.service';
import {stringify} from 'flatted';
import {I18nService} from '../../_services/gui/i18n.service';
import {NgClass} from '@angular/common';
import {ValidationErrorsComponent} from '../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [ReactiveFormsModule, NgClass, ValidationErrorsComponent, TranslateModule]
})
export class ForgotPasswordComponent implements OnInit {

  formGroup: UntypedFormGroup;
  formSubmitted: boolean;

  private formBuilder = inject(UntypedFormBuilder);
  private usersService = inject(UsersService);
  private i18nService = inject(I18nService);

  constructor() {
    const formBuilder = this.formBuilder;

    this.formGroup = formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  ngOnInit() {
    this.i18nService.setTitle('title.admin.profile.forgot-password');
  }

  submit(value: any) {
    this.formSubmitted = true;
    console.debug(stringify(value));
    console.debug(stringify(this.formGroup.controls.email.errors));
    if(this.formGroup.valid) {
      this.usersService.sendToken(value.email).subscribe(() => {
        //TODO: verify success.  But service doesn't seem to respond with anything but ok.
        this.formGroup.reset();
        this.formSubmitted = false;
      });
    }
  }
}
